import { render } from "./calendar.vue?vue&type=template&id=baf34da0&scoped=true"
import script from "./calendar.vue?vue&type=script&lang=js"
export * from "./calendar.vue?vue&type=script&lang=js"

import "./calendar.vue?vue&type=style&index=0&id=baf34da0&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-baf34da0"

export default script